import ChartGlassPanel from '../../components/ChartGlassPanel';
import { ResponsiveContainer, FunnelChart, Funnel, Tooltip, LabelList } from 'recharts';

const data = [
  { stage: 'Applied', value: 120 },
  { stage: 'Phone Screen', value: 80 },
  { stage: 'Technical Round', value: 40 },
  { stage: 'HR Round', value: 25 },
  { stage: 'Hired', value: 10 },
];

const COLORS = ['#2563eb', '#0ea5e9', '#22c55e', '#f59e42', '#e11d48'];

export default function HiringFunnelChart() {
  return (
    <ChartGlassPanel>
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <FunnelChart>
          <Tooltip formatter={(value) => `${value} candidates`} />
          <Funnel
            dataKey="value"
            data={data}
            isAnimationActive
            shape="rect"
          >
            <LabelList dataKey="stage" position="right" fill="#334155" style={{ fontWeight: 500 }} />
            {data.map((entry, idx) => (
              <cell key={`cell-${idx}`} fill={COLORS[idx % COLORS.length]} />
            ))}
          </Funnel>
        </FunnelChart>
      </ResponsiveContainer>
    </div>
    </ChartGlassPanel>
  );
}
